import Subject from "../cse4sub/Subject";
import React from 'react'

export default function EpLab() {
  return (
    <div>
       <Subject title="Engineering Physics Lab(ASH104)" sub="E. Physics Lab" syllabus="#"
    book1=" " book2=" "
    book1Link="#" book2Link="#" int21="#" mid21="#" end21="#"
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}